import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, Subject } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { CasingPlanModel, WellDirection, } from "../../new-casing-plan/models/casing-plan.model";
import { DocumentManagementService, IAzureBlobSasToken, IUploadFile } from "../../../../common/services/document-management.service";



@Component({
    selector: 'casing-plan-schematic-modal',
    templateUrl: './casing-plan-schematic-modal.component.html',
    styleUrls: ['./casing-plan-schematic-modal.component.scss'],
    standalone: false
})
export class CasingPlanSchematicModalComponent implements OnInit, OnDestroy {


    get applicationData(): { applicationNumber: string, wellName: string, wellNumber: string } {
        return {
            applicationNumber: this.applicationNumber,
            wellName: this.wellName,
            wellNumber: this.wellNumber
        };
    }

    @Input() applicationNumber: string = "";
    @Input() casingPlan: CasingPlanModel = null;

    savingDrawing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    get wellDirection(): WellDirection {
        if (this.casingPlan == null) return null;
        return this.casingPlan.wellDirection;
    }


    @Input() wellName: string = "";
    @Input() wellNumber: string = "";


    @Output() imageUpdated: EventEmitter<string> = new EventEmitter<string>();

    private dialogSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    get showDialog(): boolean {
        return this.dialogSubject.value;
    }

    subscription: Subscription = new Subscription();

    constructor(private _docService: DocumentManagementService) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    private blobToFile(blob: Blob, fileName: string): File {
        const b: any = blob;
        b.lastModifiedDate = new Date();
        b.name = fileName;
        return b as File;
    }

    cancel(): void {
        this.toggle(false);
    }

    private encodeDrawing(imageType: string): string {
        const el = document.getElementById("canvas");
        if (el) {
            const canvas = <HTMLCanvasElement>el;
            const url = canvas.toDataURL(imageType, 1.0);
            return url;
        }
        return "";
    }

    save(): void {
        const fileName = `${this.applicationNumber}_schematic.png`;
        const img = this.encodeDrawing("image/png");
        this.savingDrawing.next(true);
        this.subscription = this.saveDrawings(fileName, img).pipe(
            tap((token: IAzureBlobSasToken) => {
                this.imageUpdated.emit(token.blobUri);
            }),
            finalize(() => {
                this.toggle(false);
                this.savingDrawing.next(false);
            })
        ).subscribe(
            () => { },
            (error) => { console.error(error); }
        )
    }

    saveDrawings(name: string, url: string): Observable<IAzureBlobSasToken> {
        var data = url.split(','), mime = data[0].match(/:(.*?);/)[1], bstr = atob(data[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        const fileName = name.replace(" ", "_");
        let blobFile: File;
		blobFile = new File([u8arr], fileName, { type: mime });
        const file = { fileName: `${fileName}`, rawFile: blobFile } as IUploadFile;
        return this.uploadFile(file);
    }

    toggle(show: boolean): void {
        this.dialogSubject.next(show);
    }

    private uploadFile(file: IUploadFile): Observable<IAzureBlobSasToken> {
        const uploadComplete = new Subject<IAzureBlobSasToken>();
        return this._docService.provision(file.rawFile.name).pipe(
            tap((data: any) => {
                this._docService.processProvisionedFile(file, data, uploadComplete);
            })
        );
    }
}
